module.exports = __webpack_public_path__ + "img/user.ae4d34ee.svg";